import Big from "big.js";
import _capitalize from "lodash/capitalize";
import _lowerFirst from "lodash/lowerFirst";
import {
  UP,
  DOWN,
} from "../components/organisms/TemplateBuilder/TemplateItemEditor/FormatEditor/constants";
import { NumberFormat } from "../requests/templates/types/columnFormat";
import { numberFormatPLACEHOLDER } from "../requests/templates/types/placeholderData";

export const roundBigNumberToArbitraryValue = (
  roundTo: number,
  roundingDirection: typeof UP | typeof DOWN,
  number: Big
) => {
  if (roundTo === 0) return number;

  if (roundingDirection === UP) {
    // Big.js ekvivalent k
    // Math.ceil(number / roundTo) * roundTo;
    return Big(roundTo).mul(Math.ceil(Number(number.div(roundTo))));
  }
  // Big.js ekvivalent k
  // Math.floor(number / roundTo) * roundTo;
  return Big(roundTo).mul(Math.floor(Number(number.div(roundTo))));
};

export const applyThousandsSeparator = (separator: string, number: Big) => {
  const stringified = number.toString();

  const [wholePart, decimalPart] = stringified.split(".");
  const wholePartWithSeparator = wholePart
    .replace(/\B(?=(\d{3})+(?!\d))/g, separator)
    .replace(/ /g, "\xa0"); // Nahradí mezery tvrdejma mezerama, abych jich uměl vykreslit víc za sebou

  const hasDecimals = !!decimalPart;

  return hasDecimals
    ? `${wholePartWithSeparator}.${decimalPart}`
    : wholePartWithSeparator;
};

export const formatTableNumber = (
  format: NumberFormat,
  numberInput: number | string
) => {
  const {
    unit = numberFormatPLACEHOLDER.unit,
    divisor = numberFormatPLACEHOLDER.divisor,
    thousandsSeparator = numberFormatPLACEHOLDER.thousandsSeparator,
    roundTo = numberFormatPLACEHOLDER.roundTo,
    roundingDirection = numberFormatPLACEHOLDER.roundingDirection,
  } = format;

  if (divisor === 0) return null;

  try {
    const big = Big(numberInput);

    const divided = big.div(divisor);
    const rounded = roundBigNumberToArbitraryValue(
      roundTo,
      roundingDirection,
      divided
    );
    const withSeparator = applyThousandsSeparator(thousandsSeparator, rounded);
    return `${withSeparator} ${unit}`.trim();
  } catch (e) {
    // Hlavně když vybuchne ten Big(numberInput)
    return null;
  }
};

export const capitalizeString = <T extends string>(str: T) =>
  _capitalize(str) as Capitalize<T>;

export const uncapitalizeString = <T extends string>(str: T) =>
  _lowerFirst(str) as Uncapitalize<T>;
